import React, {useEffect, useRef, useState} from 'react';
import PageHeader1 from '../../components/common/PageHeader1';
import ActiveStatus from "../../components/Form/activeStatus";
import {useNavigate} from "react-router-dom";
import apiClient from "../../utils/api";

function WebUsersAdd() {
    const navigate = useNavigate()
    const [countries, setCountries] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        role: '',
        is_active: "1",
        dob: '',
        referral_source: '',
        nationality: ''
    });
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const fetchCountries = async () => {
        try {
            const response = await apiClient.get('countries');
            setCountries(response.data);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    useEffect(() => {
        fetchCountries();
    }, []);

    const handleInputChange = (e) => {
        const {name, value, checked} = e.target;
        if (name === "permissions") {
            setFormData((prevState) => {
                const updatedPermissions = checked ? [...prevState.permissions, value] : prevState.permissions.filter((key) => key !== value);

                return {...prevState, [name]: updatedPermissions};
            });
        } else {
            setFormData({...formData, [name]: value});
        }
    };

    /*const fetchRoles = async () => {
        try {
            const response = await apiClient.get('admin/roles');
            setRoles(response.data.data);
        } catch (error) {
            console.error('Error fetching roles:', error);
        }
    }*/

    /*useEffect(() => {
        fetchRoles();
    }, []);*/

    const onSubmit = async (e) => {
        e.preventDefault();
        //setLoading(true)
        const data = new FormData();
        data.append('name', formData.name);
        data.append('email', formData.email);
        data.append('dob', formData.dob);
        data.append('nationality', formData.nationality);
        data.append('is_active', formData.is_active);
        data.append('referral_source', formData.referral_source);

        if (selectedFile) {
            data.append('image', selectedFile);
        }

        try {
            const response = await apiClient.post('admin/webusers', data);
            //toast.success(response.data.message);
            navigate(process.env.PUBLIC_URL + '/web-users-list');

        } catch (error) {
            //toast.error('Error adding product');
        } finally {
            //setLoading(false);
        }
    }

    return (<div className="container-xxl">
            <form onSubmit={onSubmit}>
                <PageHeader1 pagetitle='User Add' button={true}/>
                <div className="row g-3">
                    <div className="col-xl-3 col-lg-3">
                        <div className="sticky-lg-top">
                            <div className="card mb-3">
                                <ActiveStatus
                                    onStatusChange={handleInputChange}
                                    checked={formData.is_active}
                                    name="is_active"
                                />
                            </div>

                            <div className="card mb-3">
                                <div className="col-md-12">
                                    <div
                                        className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                                        <label className="form-label">Image Upload</label>
                                        <small className="d-block text-muted mb-2"> 2M max.</small>
                                    </div>
                                    <div className="card-body">
                                        <div id='create-token' className='dropzone'>
                                            {selectedFile ? <img src={URL.createObjectURL(selectedFile)} alt=''/> :
                                                <div className='dz-message '>
                                                    <i className="fa   fa-picture-o" aria-hidden="true"></i>
                                                </div>}
                                            <input
                                                id='filesize'
                                                onChange={handleFileChange}
                                                name="file"
                                                type="file"
                                                accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, .mp4, .webm, .mp3, awv, .ogg, .glb"></input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-9 col-lg-9">
                        <div className="card mb-3">
                            <div
                                className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                                <h6 className="mb-0 fw-bold ">Basic information</h6>
                            </div>
                            <div className="card-body">
                                <form>
                                    <div className="row g-3 align-items-center">
                                        <div className="col-md-6">
                                            <label className="form-label">Name</label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Email</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.email}
                                                name="email"
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label">Nationality</label>
                                            <select
                                                value={formData.nationality}
                                                onChange={handleInputChange}
                                                name="nationality"
                                                className="form-control"
                                            >
                                                <option value="">Select Nationality</option>
                                                {countries.map((country) => (
                                                    <option value={country.countryName}>{country.countryName}</option>))}
                                            </select>
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label">Date Of Birth</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={formData.dob}
                                                name="dob"
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        {/* <div className="col-md-6">
                                            <label className="form-label">Preferences</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.preferences}
                                                name="preferences"
                                                onChange={handleInputChange}
                                            />
                                        </div>*/}

                                        <div className="col-md-6">
                                            <label className="form-label">Referral Source</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.referral_source}
                                                name="referral_source"
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>


                    </div>
                </div>
            </form>
        </div>

    )
}

export default WebUsersAdd;